const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const TENANT_ID = process.env.REACT_APP_TENANT_ID;
const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI || window.location.origin;

export const isConfigured = Boolean(CLIENT_ID && TENANT_ID);

// If env vars are missing, the app will show SetupRequired screen instead of crashing.
// No console output in production.

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${TENANT_ID || "common"}`,
    knownAuthorities: ["login.microsoftonline.com"],
    redirectUri: REDIRECT_URI,
    postLogoutRedirectUri: REDIRECT_URI,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    allowNativeBroker: false,
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
    loggerOptions: {
      loggerCallback: () => {},
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "email"],
  prompt: "select_account",
};
